import { Link } from "react-router-dom";
import { CalendarDays, UsersRound } from "lucide-react";
import { InfinityCommissionItem } from "../../../../Redux/referral/types";
import {
  formatEarningsCurrency,
  mapInfinityItemToSummary,
} from "../earningsAdapters";

interface Props {
  data: InfinityCommissionItem[];
}

const PrtCommissionTable = ({ data }: Props) => {
  const rows = (data || []).map(mapInfinityItemToSummary);

  return (
    <div className="samriddhi-desktop-table-wrap">
      <table className="samriddhi-table">
        <thead>
          <tr>
            <th>S.NO</th>
            <th>MONTH - YEAR</th>
            <th>CONTRIBUTORS</th>
            <th>RECEIVED INCENTIVES</th>
            <th>TDS</th>
            <th>PENDING</th>
            <th>CANCELLED</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((record, index) => (
            <tr key={record.id}>
              <td>
                <strong>{index + 1}</strong>
              </td>
              <td>
                <div className="samriddhi-period-cell">
                  <CalendarDays size={17} />
                  <strong>
                    {record.monthYearLabel ||
                      `${new Date(record.year, record.month - 1).toLocaleString("default", { month: "long" })} - ${record.year}`}
                  </strong>
                </div>
              </td>
              <td>
                <Link
                  className="samriddhi-contributor-button"
                  to={`/PrtCommissonDetails?date=${record.monthYear}`}
                >
                  <UsersRound size={17} />
                  <strong>{record.totalPurchases}</strong>
                  <span>View contributors</span>
                </Link>
              </td>
              <td>
                <strong className="samriddhi-amount">
                  {formatEarningsCurrency(record.totalCommissionEarned)}
                </strong>
              </td>
              <td>
                <strong className="samriddhi-amount">
                  {formatEarningsCurrency(record.tdsAmount ?? 0)}
                </strong>
              </td>
              <td>
                <strong className="samriddhi-amount">
                  {formatEarningsCurrency(record.totalPendingCommission)}
                </strong>
              </td>
              <td>
                <strong className="samriddhi-amount">
                  {formatEarningsCurrency(record.totalCancelledCommission)}
                </strong>
              </td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr>
              <td colSpan={7}>No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PrtCommissionTable;
